<div [class.p-3]="exploreMoreWithResources">
    @if (exploreMoreWithResources) {
        <li>
            <a href="https://www.facebook.com/groups/599875418637774/" id="live-community-link" class="sidebar-v2-link" target="_blank">
                <div class="item-content">
                    <div class="item-inner">
                        <span class="title">Live Community</span>
                        <i class="icon-ic-external-link-s1 icon-outline"></i>
                        <i class="icon-ic-external-link-s2 icon-filled"></i>
                    </div>
                </div>
            </a>
        </li>

        <li>
            <a [routerLink]="['resources', 'content']" class="sidebar-v2-link">
                <div class="item-content">
                    <div class="item-inner"><span class="title">Watch & Learn</span></div>
                </div>
            </a>
        </li>
        <li>
            <a [routerLink]="['resources', 'partners']" class="sidebar-v2-link">
                <div class="item-content">
                    <div class="item-inner"><span class="title">Partners</span></div>
                </div>
            </a>
        </li>
    }

    <li>
        <a #alink class="sidebar-v2-link" id="btn-explore-whats-new" href="https://news.buildxact.com/" target="_blank">
            <div class="item-content">
                @if (!exploreMoreWithResources) {
                    <div class="item-media">
                        <i class="icon-ic-whats-new-s1 icon-outline"></i>
                        <i class="icon-ic-whats-new-s2 icon-filled"></i>
                    </div>
                }
                <div class="item-inner">
                    <span class="title">What&rsquo;s New</span>
                    <i class="icon-ic-external-link-s1 icon-outline"></i>
                    <i class="icon-ic-external-link-s2 icon-filled"></i>
                </div>
            </div>
        </a>
    </li>

    <li>
        <a #alink class="sidebar-v2-link" (click)="openFeedbackPage(alink)">
            <div class="item-content">
                @if (!exploreMoreWithResources) {
                    <div class="item-media">
                        <i class="icon-ic-suggest-to-us-s11 icon-outline"></i>
                        <i class="icon-ic-suggest-to-us-s1 icon-filled"></i>
                    </div>
                }
                <div class="item-inner" id="suggest-to-us-button">
                    <span class="title">Feature Suggestions</span>
                    <i class="icon-ic-external-link-s1 icon-outline"></i>
                    <i class="icon-ic-external-link-s2 icon-filled"></i>
                </div>
            </div>
        </a>
    </li>
</div>
